import { Component, Input } from '@angular/core';

@Component({
    selector: 'ca-folder-item',
    templateUrl: './folder-item.component.html',
    styleUrls: ['./folder-item.component.scss'],
})
export class FolderItemComponent {
    @Input() name: string;
    @Input() numberOfFiles?: number;

    hasFiles(): boolean {
        return this.numberOfFiles != null && this.numberOfFiles > 0;
    }
}
